import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Orientace datové tabulky per-produkt (report). Klíč = slug produktu (klíč v REPORT_MAP
// v StationDetailLayout, resp. productSlug u skupinových view).
//   'normal'     – dosavadní rozložení (řádky = čas / stanice, sloupce = veličiny / …)
//   'transposed' – prohozené řádky a sloupce
// Persistováno do localStorage – volba má přežít reload i zavření tabu (period story jedou
// přes sessionStorage, ale orientace je dlouhodobá uživatelská preference).
export const useTableOrientationStore = create(
  persist(
    (set, get) => ({
      byProduct: {},
      getOrientation: (slug) => get().byProduct[slug] ?? 'normal',
      toggle: (slug) =>
        set((s) => ({
          byProduct: {
            ...s.byProduct,
            [slug]: (s.byProduct[slug] ?? 'normal') === 'normal' ? 'transposed' : 'normal',
          },
        })),
      setOrientation: (slug, value) =>
        set((s) => ({ byProduct: { ...s.byProduct, [slug]: value } })),
    }),
    {
      name: 'table-orientation',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
